import { Component, OnInit, Injector, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { trigger, state, style, transition, animate } from '@angular/animations';
declare var $: any;
import { LoadingService } from '../../../util/loader.service';
import { EmpresaService } from './empresa.service';

const swal = require('sweetalert');
import { saveAs } from 'file-saver';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Empresa } from '../../../models/empresa/empresa';
import { ModalOptions } from 'ngx-bootstrap/modal/modal-options.class';
import { ModalInformacaoEmpresaComponent } from './modal-informacao-empresa/modal-informacao-empresa.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
const b64toBlob = require('b64-to-blob');

@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.scss'],
  animations: [
    trigger('filterBlur', [
      state('hide', style({
        opacity: 1
      })),
      state('show', style({
        opacity: 0
      })),
      transition('hide => show', animate('200ms ease-in')),
      transition('show => hide', animate('200ms ease-out'))
    ]),
  ],
  encapsulation: ViewEncapsulation.None
})
export class EmpresaComponent implements OnInit, OnDestroy {
  rows: Object[]
  public modalRef: BsModalRef;
  timerId;
  selected = [];
  registroSelecao = [];
  parametroConsulta: string;
  filterState: boolean = true;
  valForm: FormGroup;
  selectCheck;
  page = {
    limit: 20,
    count: 0,
    offset: 0,
    descricao: '',
    estado: '',
    ativo: true,
  };
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  acoesBottoes: boolean = true;
  botoesAtivados = false;
  blur = false;
  estados = [];

  public searchTypedTipoCliente = new BehaviorSubject('');

  @ViewChild(DatatableComponent) table: DatatableComponent;

  ngOnDestroy(): void {

  }

  constructor(public service: EmpresaService, public injector: Injector, private route: ActivatedRoute, private router: Router, public loader: LoadingService, fb: FormBuilder, private modalService: BsModalService) {
    this.reloadTable();
    this.loadEstados();
    this.valForm = fb.group({
      'itemFormEstado': [null, null],
    });
    /* this.searchTypedTipoCliente
   .distinctUntilChanged()
   .filter((str: string) => str.length > 2 || str.length === 0)
   .subscribe((str) => {
     this.service.estados(str).subscribe(itens => this.estados = itens);
   });*/
  }

  openModalInformacaoEmpresa(event) {


    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {

      this.loader.show("body");
      this.service.obterInformacoesEmpresa(this.registroSelecao[0].id_empresa)
        .subscribe((itens) => {
          this.loader.hide("body");
          const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            animated: true,
            class: 'modal-lg',
           // size: 'lg', // sm, md, lg
            ignoreBackdropClick: true,
            initialState: {
              record: itens
            }
          };
          this.modalRef = this.modalService.show(ModalInformacaoEmpresaComponent, config);

          this.modalRef.content.onClose.subscribe(result => {
            this.reloadTable();
            this.registroSelecao = [];
            this.selected = [];
          });
        });

    }

  }
  ativarFiltros($event) {
    this.blur = !this.blur;
  }

  fecharFiltro($event): void {
    this.blur = !this.blur;
  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.page.count = itens.count;
        this.rows = itens.rows;

        this.botoesAtivados = true;
      });

  }

  loadEstados() {
    this.service.estados('')
      .subscribe(itens => {
        this.estados = itens;
      });
  }
  limparVariavelEstado(){
    this.page.estado = "";
  }
  pesquisar($ev, value) {
    this.page.offset = 0;
    //this.valForm.controls['consultar'].enable();
    this.blur = false;
    this.reloadTable();
  }
  filtro(event) {
    this.page.descricao = this.parametroConsulta;
    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => { this.page.offset = 0; this.reloadTable(); }, 1000);
  }

  estadoSelecionado($event, a) {

  }

  onFilterChange(eve: any) {
    this.limparSelecionados();
    this.page.ativo = eve;
    this.reloadTable();
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.registroSelecao = [];
    this.reloadTable();
  }

  removerRegistro() {
    swal({
      title: 'Atenção',
      text: 'Você deseja alterar o status desse registro?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1E0136',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      closeOnConfirm: false
    }, () => {
      var ids = [];
      this.registroSelecao.forEach(function (s) {
        ids.push(s.codigo);
      });
      this.service.AtivarOuInativar(ids)
        .subscribe(result => {
          if (result.success) {
            this.limparSelecionados();
            this.reloadTable();
            swal('Atenção', 'Ação realizada com sucesso.', 'success');
          }
        });
    });
  }

  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }


  linkNovo() {
    this.router.navigate(['/fidel/empresa/novo']);
  }
  linkEdit() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.router.navigate(['/fidel/empresa/editar/' + this.registroSelecao[0].id_empresa]);
    }
  }

  linkAlterarSenha() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "data": JSON.stringify(this.registroSelecao[0]),
        },
        skipLocationChange: true
      };
      this.router.navigate(['/fidel/empresa/alterarsenha'], navigationExtras);
    }
  }
  linkRegistrarContato() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "data": JSON.stringify(this.registroSelecao[0]),
        },
        skipLocationChange: true
      };
      this.router.navigate(['/fidel/empresa/registrarcontato'], navigationExtras);

      //this.router.navigate(['/fidel/empresa/registrarcontato/' + this.registroSelecao[0].id_empresa]);
    }
  }


  linkAplicarCortesia() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.router.navigate(['/fidel/empresa/aplicarcortesia/' + this.registroSelecao[0].codigo]);
    }
  }

  linkParametroPagamento() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.router.navigate(['/fidel/empresa/parametropagamento/' + this.registroSelecao[0].codigo]);
    }
  }

  ngOnInit() {
  }

  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_empresa == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].codigo == item[0].codigo) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }

  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;
  }

  exportarExcel() {
    this.loader.show('body');
    this.botoesAtivados = false;
    this.service.obterExcel(this.page).subscribe((result) => {
      if (result.success) {
        const blob = b64toBlob(result.data.fileBase64, result.data.fileType);

        saveAs(blob, result.data.fileName, {
          type: result.data.fileType
        });
      } else {
        if (result === 'obterExcel') {
          swal('Atenção', 'Ação não realizada com sucesso.', 'error');
        }
      }
      this.botoesAtivados = true;
      this.loader.hide('body');
    });
  }

  exportarPdf() {
    this.loader.show('body');
    this.botoesAtivados = false;
    this.service.obterPdf(this.page).subscribe((result) => {
      if (result.success) {
        const blob = b64toBlob(result.data.fileBase64, result.data.fileType);

        saveAs(blob, result.data.fileName, {
          type: result.data.fileType
        });
      } else {
        if (result === 'obterPdf') {
          swal('Atenção', 'Ação não realizada com sucesso.', 'error');
        }
      }
      this.botoesAtivados = true;
      this.loader.hide('body');
    });
  }
}
